import { MutationCache, QueryClient } from "@tanstack/react-query";
import { IMPERSONATION_READ_ONLY } from "@mfa-aff/shared";
import { errorMessage, notify } from "@mfa-aff/ui";
import { ApiError } from "./client";

declare module "@tanstack/react-query" {
    interface Register {
        /** `meta: { silent: true }` on a mutation skips the default error toast (the page shows its own). */
        mutationMeta: { silent?: boolean };
    }
}

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 60_000,
            refetchOnWindowFocus: false,
            // 4xx are answers, not glitches: do not retry them.
            retry: (count, error) => !(error instanceof ApiError && error.status < 500) && count < 2,
        },
    },
    mutationCache: new MutationCache({
        onError: (error, _vars, _ctx, mutation) => {
            if (mutation.options.meta?.silent) return;
            // Refused during an admin's read-only view: the API client already showed its one toast.
            if (error instanceof ApiError && error.code === IMPERSONATION_READ_ONLY) return;
            notify.error("انجام نشد", { description: errorMessage(error) });
        },
    }),
});
